import { render } from "./LotteryHome.vue?vue&type=template&id=7be53410"
import script from "./LotteryHome.vue?vue&type=script&lang=js"
export * from "./LotteryHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__